import { CapiMessageContent } from "../types";

export const defaultMessage: CapiMessageContent = {
  highlightsTitle: "Today's Highlights",
  title: "Top Pools",
  upcomingTitle: "Coming Up"
};
